import Content from '@/next/components/Content/Content';

export default Content;
